import { render, staticRenderFns } from "./PublishPresentations.vue?vue&type=template&id=0ee5ab6c&scoped=true&"
import script from "./PublishPresentations.vue?vue&type=script&lang=js&"
export * from "./PublishPresentations.vue?vue&type=script&lang=js&"
import style0 from "./PublishPresentations.vue?vue&type=style&index=0&id=0ee5ab6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5ab6c",
  null
  
)

export default component.exports